export function addressToString(address, oneLine = true){
  const firstLine = `${address.street} ${address.houseNumber}${address.bus && ` bus ${address.bus}`}`
  const secondLine = `${address.postalCode} ${address.city}`
  const separator = oneLine ? `, ` : `\n`
  return firstLine + separator + secondLine
}
